module.exports = __webpack_public_path__ + "static/media/BJCHealthCare.9918162f.png";